import React, { useEffect, useState } from 'react'
import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Loader } from 'components'
import { Alert } from '@mui/material'
import { fetchBusinesses } from 'modules/User/actions'
import BusinessContainer from './modules/BusinessContainer'
import BusinessCreator from '././modules/BusinessCreator'
import api from 'utils/api'
import { businessPath } from 'utils/businessRoutes'
import ErrorBoundary from './ErrorBoundry';
import { currentPageUrl, loginUrl } from 'utils/loginRedirect'
import { getSession, isCurrentSession } from 'utils/session'

const Business = () => {
  const [loadingBusiness, setLoadingBusiness] = useState(false)
  const location = useLocation()
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)

  useEffect(() => {
    if (user.details && !user.businesses) {
      const context = getSession()
      setLoadingBusiness(true)
      api.get('/user/businesses')
        .then(res => {
          if (!isCurrentSession(context)) return
          setLoadingBusiness(false)
          dispatch(fetchBusinesses(res.content))
        })
        .catch(() => setLoadingBusiness(false))
    }
  }, [user.businesses, user.details, dispatch])

  if (user.isFetching) {
    return <Loader />
  }

  if (!user.details) {
    return <Navigate to={loginUrl(currentPageUrl(location))} replace />
  }

  if (loadingBusiness || !user.businesses) {
    return <Loader />
  }

  const targetsBusiness = /^\/business-account\/\d+\/business\/\d+(?:\/|$)/.test(location.pathname)
  if (!user.businesses.length && !targetsBusiness) {
    return <><Alert severity="info">No owned businesses</Alert><BusinessCreator /></>
  }

  const defaultBusiness = user.businesses.find(b => b.businessId === user.details.defaultBusinessId) || user.businesses[0]

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ErrorBoundary>
      <Routes>
      {user.businesses.length > 0 && <Route index element={<Navigate to={businessPath(defaultBusiness.businessId, defaultBusiness.organizationId)} replace />} />}
      <Route path=":businessId/*" element={<BusinessContainer />} />
      </Routes>
      </ErrorBoundary>
      </LocalizationProvider>
  )
}

export default Business
